import dayjs from 'dayjs';
import { IActivity } from '../interfaces/IActivity';
import { ActivityType } from '../enums/ActivityCalendar.enum';
import { IAnchor } from '../interfaces/IAnchor';
import { ACTIVITY_TYPE_SORT_ORDER, MONDAY_FIRST_WEEK_OFFSET, DAYS_PER_WEEK, typeOrder } from '../constants';

export const weekStart = (date: dayjs.Dayjs): dayjs.Dayjs => {
  const daysSinceMonday = (date.day() + MONDAY_FIRST_WEEK_OFFSET) % DAYS_PER_WEEK;
  return date.subtract(daysSinceMonday, 'day').startOf('day');
};

export const indexBy = (list: IActivity[]): Record<string, IActivity[]> => {
  const activityIndex: Record<string, IActivity[]> = {};
  list.forEach((activity) => {
    (activityIndex[activity.dateKey] = activityIndex[activity.dateKey] || []).push(activity);
  });
  return activityIndex;
};

export const dominant = (acts: IActivity[]): ActivityType => {
  const counts: Partial<Record<ActivityType, number>> = {};
  acts.forEach((activity) => {
    counts[activity.type] = (counts[activity.type] || 0) + 1;
  });
  let best: ActivityType = acts[0].type;
  let highestCount = -1;
  ACTIVITY_TYPE_SORT_ORDER.forEach((activityType) => {
    if ((counts[activityType] || 0) > highestCount) {
      highestCount = counts[activityType] || 0;
      best = activityType;
    }
  });
  return best;
};

export const sortByType = (activities: IActivity[]): IActivity[] =>
  activities.slice().sort((leftActivity, rightActivity) => typeOrder(leftActivity.type) - typeOrder(rightActivity.type));

export const anchorToDayjs = (anchor: IAnchor): dayjs.Dayjs =>
  dayjs(new Date(anchor.year, anchor.monthIndex, anchor.dayOfMonth));

export const dayKey = (date: dayjs.Dayjs): string => `${date.year()}-${date.month()}-${date.date()}`;

export const getRecordPath = (activity: IActivity): string | null => {
  if (!activity.recordId) return null;
  if (activity.type === ActivityType.Spray) return `/spray-record/update/${activity.recordId}`;
  if (activity.type === ActivityType.Dry) return `/fertiliser-application/dry-application/update/${activity.recordId}`;
  if (activity.type === ActivityType.Fertigation) return `/fertiliser-application/fertigation/update/${activity.recordId}`;
  return null;
};
